import PropTypes from 'prop-types';
import React, { useEffect, useRef } from 'react';
import cx from 'classnames';
import EasyMDE from 'easymde';
import styles from './FormRichTextEditor.module.scss';

const FormRichTextEditor = ({
  name,
  label,
  placeholder,
  setValue,
  errors,
  register,
  defaultValues,
}) => {
  const initialValue = (defaultValues && defaultValues[name]) || '';

  const textareaEl = useRef(null);
  const easyMDE = useRef(null);

  function handleChange(value) {
    setValue(name, value);
  }

  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    register({ name });
  }, []);

  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    easyMDE.current = new EasyMDE({
      element: textareaEl.current,
      forceSync: true,
      status: [
        {
          className: 'keystrokes',
          onUpdate: function(el) {
            if (easyMDE.current) {
              handleChange(easyMDE.current.value());
              // console.log(easyMDE.value());
            }
          },
        },
      ],
      initialValue,
      placeholder,
    });
  }, []);

  return (
    <div
      className={cx(styles.formRichTextEditor, errors[name] ? 'has-error' : '')}
    >
      {label && (
        <label htmlFor={name}>
          <strong>{label}</strong>
          {/* {asyncValidating && <i className="icon-spinner fa-spin" />} */}
        </label>
      )}
      <textarea ref={textareaEl}></textarea>
      {errors[name] && (
        <span className="help-block">{errors[name].message}</span>
      )}
    </div>
  );
};

FormRichTextEditor.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  setValue: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired,
  register: PropTypes.func.isRequired,
  defaultValues: PropTypes.object,
};

export default FormRichTextEditor;
